import React, { useState, useEffect, useContext } from "react";
import api from "../../../services/api";
import { useParams } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Content from "../../../components/Content";
import CardHeader from "../../../components/CardHeader";
import CardFooter from "../../../components/CardFooter";
import Button from "../../../components/Button";
import { toast } from "react-toastify";

import { getUFS } from './UFs'

import { Context } from './Context';
import {
  validaCpf
} from "../../../util/rotinas";

const RepresentanteNovo = (props) => {

  const { id } = useParams()
  const [loading, setLoading] = useState(false);
  const [dataAtual, setDataAtual] = useState(undefined)
  const { isEdit, isCreate, handleClose, representanteEdit, isOpenModal } = useContext(Context);

  const [form, setForm] = useState({})

  function handleForm(key, value) {
    setForm({
      ...form,
      [key]: value
    })
  }

  useEffect(() => {
    if (dataAtual === undefined) {
      let data = new Date();
      let dia = String(data.getDate()).padStart(2, '0');
      let mes = String(data.getMonth() + 1).padStart(2, '0');
      let ano = data.getFullYear();
      let dataAtual = ano + '-' + mes + '-' + dia;
      setDataAtual(dataAtual)
    }
  }, [dataAtual])


  // //PRE CARREGAMENTO DE INFORMACOES
  // useEffect(() => {
  //   if (form && !form.hasOwnProperty('flgBloqueado')) {
  //     handleForm('flgBloqueado', false)
  //   }
  //   if (form && !form.hasOwnProperty('date_f')) {
  //     handleForm('dataCadastro', dataAtual)
  //   }
  // }, [dataAtual, form, handleForm])


  useEffect(() => {
    if (isEdit) {
      if (representanteEdit !== undefined) {
        setForm(representanteEdit)
      }
    }
  }, [isEdit, isOpenModal, representanteEdit])


  const [cities, setCities] = useState(undefined)

  async function getCities(UF) {
    const request = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${UF}/municipios`)
    const result = await request.json()
    setCities(result)
  }

  const [UFs, setUFs] = useState(undefined)
  async function getUFS() {
    const request = await fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
    const result = await request.json()
    setUFs(result)
  }

  useEffect(() => {
    if (UFs === undefined) {
      getUFS()
    }
  }, [getUFS])

  useEffect(() => {
    if (form && form['state'] !== undefined) {
      getCities(form['state'])
    }
  }, [form['state']])

  function buildOptionsUF() {
    if (UFs) {
      return UFs.map(uf => {
        return <option key={uf.id} value={uf.sigla}>{uf.sigla}</option>
      })
    }
  }
  function buildOptionsCities() {
    if (cities) {
      return cities.map(city => {
        return <option key={city.id} value={city.nome}>{city.nome}</option>
      })
    }
  }

  const handleSubmit = function (e, errors, values) {
    if (errors.length === 0) {
      e.preventDefault()
      try {
        setLoading(true);
        if (isCreate) {
          form['customer_id'] = Number(id)
          api.post("/representative", {
            ...form,
            date_birth: form.date_birth + 'T00:00:00.000Z',
            phone: form.phone.replace(/[^0-9]/g, '')
          }).then(result => {
            if (result.data.data.message) {
              toast.error(`${result.data.data.message}`, {
                position: "bottom-center",
                autoClose: true,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: 0,
              });
            }
            else {
              if (result.data.sucess === true) {
                toast.success(`Novo Representante incluido com sucesso.`, {
                  position: "bottom-center",
                  autoClose: true,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: 0,
                });
                window.location.reload();
              }
              else {
                toast.error(`Erro durante a adição de um novo representante.`, {
                  position: "bottom-center",
                  autoClose: true,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: 0,
                });
              }
            }
          }).catch(err => {
            console.log(err)
          });
        } else if (isEdit) {
          let temp = form
          api.put('/representative', {
            ...temp,
            date_birth: temp.date_birth + 'T00:00:00.000Z',
            phone: form.phone.replace(/[^0-9]/g, '')
          }).then(result => {
            if (result.data.data.message) {
              toast.error(`${result.data.data.message}`, {
                position: "bottom-center",
                autoClose: true,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: 0,
              });
            }
            else {
              if (result.data.sucess === true) {
                toast.success(`Representante editado com sucesso`, {
                  position: "bottom-center",
                  autoClose: true,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: 0,
                });
                window.location.reload();
              }
              else {
                toast.error(`Erro durante a edição do representante`, {
                  position: "bottom-center",
                  autoClose: true,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: 0,
                });
              }
            }
          }).catch(err => {
            console.log(err)
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }
  };

  function validate(params) {
    if (params === undefined || params === null || params.trim() === '') {
      return true
    }
    return false
  }

  const validateCPF = ((value, ctx, input, cb) => {
    let temp = ''
    if (form['cpf'] !== undefined) {
      temp = form['cpf']
    }
    cb(validaCpf(temp));
  });

  function enableCreateRepresentante(rep) {
    if (validate(rep.name) || validate(rep.name_mother)
      || validate(rep.date_birth) || validate(rep.cpf)
      || validate(rep.phone) || validate(rep.email)
      || validate(rep.address) || validate(rep.address_number)
      || validate(rep.city) || validate(rep.district)
      || validate(rep.state) || validate(rep.zip_code)) {
      return false
    }
    return true
  }

  function handlePhone(args){
    args = args.replace(/\D/g,'')
    args = args.replace(/(\d{2})(\d)/,"($1) $2")
    args = args.replace(/(\d)(\d{4})$/,"$1-$2")
    return args
  }

  return (
    <Content>
      <CardHeader
        title={"Cadastrar Representante"}
        searchVisible={false}
      />
      <div style={{}} className="box">
        <AvForm onSubmit={handleSubmit}>
          <div className="row" style={{ display: "flex", padding: "10px 10px 10px 10px" }}>
            <div className="col-md-5">
              <div className="form-group">
              
                <AvField
                  type="text"
                  name="name"
                  label="Nome *"
                  placeholder="Nome"
                  value={form['name'] ? form['name'] : ''}
                  onInput={(e) => handleForm('name', e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <AvField
                  type="text"
                  name="name_mother"
                  label="Nome da mãe *"
                  placeholder="Nome da mãe"
                  value={form['name_mother'] ? form['name_mother'] : ''}
                  required
                  onInput={(e) => handleForm('name_mother', e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <AvField
                  type="text"
                  name="cpf"
                  label="CPF *"
                  placeholder="CPF"
                  pattern="^[0-9]*$"
                  value={form['cpf'] ? form['cpf'] : ''}
                  onInput={(e) => handleForm('cpf', e.target.value)}
                  validate={{ validateCPF }}
                  errorMessage="A string inserida não corresponde a um CPF válido."
                  required
                />
              </div>
            </div>
            <div className="col-md-5">
              <div className="form-group">
                <AvField
                  type="date"
                  name="date_birth"
                  label="Data de Nascimento *"
                  placeholder="Data de Nascimento"
                  required
                  value={form['date_birth'] ? form['date_birth'] : ''}
                  onInput={(e) => handleForm('date_birth', e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <AvField
                  type="select"
                  name="state"
                  label="UF *"
                  placeholder="UF"
                  value={form['state'] ? form['state'] : ''}
                  onChange={(event) => handleForm('state', event.target.value)}
                >
                  <option value={null}>-</option>
                  {buildOptionsUF()}
                </AvField>
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <AvField
                  type="select"
                  name="state"
                  label="Cidade *"
                  placeholder="Cidade"
                  value={form['city'] ? form['city'] : ''}
                  onChange={(event) => handleForm('city', event.target.value)}
                >
                  <option value={null}>-</option>
                  {buildOptionsCities()}
                </AvField>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <AvField
                  type="text"
                  name="district"
                  label="Bairro *"
                  placeholder="Bairro"
                  value={form['district'] ? form['district'] : ''}
                  onInput={(e) => handleForm('district', e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <AvField
                  type="text"
                  name="zip_code"
                  label="CEP *"
                  placeholder="CEP"
                  required
                  value={form['zip_code'] ? form['zip_code'] : ''}
                  onInput={(e) => handleForm('zip_code', e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <AvField
                  type="text"
                  name="address"
                  label="Logradouro *"
                  required
                  placeholder="Logradouro"
                  value={form['zip_code'] ? form['address'] : ''}
                  onInput={(e) => handleForm('address', e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-1">
              <div className="form-group">
                <AvField
                  type="text"
                  name="address_number"
                  label="N° *"
                  placeholder="N°"
                  required
                  value={form['address_number'] ? form['address_number'] : ''}
                  onInput={(e) => handleForm('address_number', e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <AvField
                  type="text"
                  name="complement"
                  label="Complemento"
                  placeholder="Complemento"
                  value={form['complement'] ? form['complement'] : ''}
                  onInput={(e) => handleForm('complement', e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <AvField
                  type="text"
                  name="phone"
                  label="Telefone *"
                  placeholder="Telefone"
                  required
                  maxLength={15}
                  // value={form['phone'] ? handlePhone(form['phone']) : ''}
                  value={form['phone'] ? handlePhone(form['phone']) : ''}
                  onInput={(e) => handleForm('phone', e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <AvField
                  type="email"
                  name="Email"
                  label="Email *"
                  placeholder="Email"
                  required
                  value={form['email'] ? form['email'] : ''}
                  onInput={(e) => handleForm('email', e.target.value)}
                />
              </div>
            </div>

          </div>
          <CardFooter loading={loading}>
            {enableCreateRepresentante(form) ?
              <Button type="submit" title="Salvar" loading={loading} />
              :
              <Button type="submit" title="Salvar" disabled loading={loading} />
            }
            <Button
              type="button"
              title="Cancelar"
              isCanceled
              loading={loading}
              onClick={handleClose}
            />
          </CardFooter>
        </AvForm>
      </div>
    </Content>

  )
};


export default RepresentanteNovo;